import { render, staticRenderFns } from "./RirekishoEdit.vue?vue&type=template&id=436b5418&scoped=true&"
import script from "./RirekishoEdit.vue?vue&type=script&lang=js&"
export * from "./RirekishoEdit.vue?vue&type=script&lang=js&"
import style0 from "./RirekishoEdit.vue?vue&type=style&index=0&id=436b5418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b5418",
  null
  
)

export default component.exports